import React from 'react';
import PropTypes from 'prop-types';
import queryString from 'query-string';
import {createSelector} from 'reselect';
import {connect} from 'react-redux';

import {bindDispatch} from 'app/utils/redux';
import {history} from 'store';
import * as routePath from 'app/utils/routePath';

import {ResetPasswordView} from 'dk-ui-lib';

const ResetPasswordContainer = (props) => {
  let {profile, actions} = props;
  let {updateNewPassword, 
    updateConfirmNewPassword, resetPassword} = actions;

  let parsed = queryString.parse(window.location.search);
  let token = parsed && parsed.token;

  return (
    <div className='m2 flex justify-center'>
      <ResetPasswordView
        profile={profile}
        token={token}
        history={history}
        routePath={routePath}
        updateNewPassword={updateNewPassword}
        updateConfirmNewPassword={updateConfirmNewPassword}
        resetPassword={resetPassword}
      />
    </div>
  );
}

const selector = createSelector(
  state => state.profile,
  (profile) => ({ profile })
);

ResetPasswordContainer.propTypes = {
  profile: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired
};

export default connect(selector, bindDispatch)(ResetPasswordContainer);


// WEBPACK FOOTER //
// ./src/containers/profile/ResetPasswordContainer.js